import * as tslib_1 from "tslib";
import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Label } from 'office-ui-fabric-react/lib/Label';
import updateTxpFlag from '../actions/updateTxpFlag';
import { getLabelForTxpFlag, isEventTypeEnabled, EventsInOptionsPageInOrder, } from '../utils/getTxpFlagInfo';
var styles = require('./TxpOptions.scss');
var TxpEventsPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TxpEventsPanel, _super);
    function TxpEventsPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * On change handler for the OptionsCheckbox
         */
        _this.updateFlagFromCheckbox = function (flag) { return function (ev, checked) {
            updateTxpFlag(flag, checked);
        }; };
        return _this;
    }
    TxpEventsPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, formFlags = _a.formFlags, mailboxCalendarConfiguration = _a.mailboxCalendarConfiguration, flagsDisabled = _a.flagsDisabled;
        return (React.createElement("div", { className: styles.txpEventsPanel },
            React.createElement(Label, null, strings.options_txp_addEventsTitle),
            EventsInOptionsPageInOrder.map(function (eventType) {
                if (!isEventTypeEnabled(eventType)) {
                    return null;
                }
                var checked = getFallbackValueIfNull(formFlags[eventType], mailboxCalendarConfiguration[eventType]);
                return (React.createElement(OptionsCheckbox, { checked: checked, disabled: flagsDisabled, onChange: _this.updateFlagFromCheckbox(eventType), label: getLabelForTxpFlag(eventType) }));
            })));
    };
    TxpEventsPanel = tslib_1.__decorate([
        observer
    ], TxpEventsPanel);
    return TxpEventsPanel;
}(React.Component));
export default TxpEventsPanel;
//# sourceMappingURL=TxpEventsPanel.js.map